export enum ReplyFrom {
  CUSTOMER = 'CUSTOMER',
  AUDITOR = 'AUDITOR',
}
